import type { ReactNode } from 'react';
import styles from './SkeletonContainer.module.scss';

export interface SkeletonContainerProps {
  /** Whether content is currently loading */
  loading: boolean;
  /** The skeleton UI to show while loading */
  skeleton: ReactNode;
  /** The real content to show when loaded */
  children: ReactNode;
  /** Accessible label describing what is loading (default: 'Content') */
  label?: string;
  /** Additional CSS class for the container */
  className?: string;
}

export function SkeletonContainer({
  loading,
  skeleton,
  children,
  label = 'Content',
  className,
}: SkeletonContainerProps) {
  const classes = [styles.container, className].filter(Boolean).join(' ');

  return (
    <div aria-busy={loading} className={classes}>
      <div role="status" className={styles.visuallyHidden}>
        {loading ? `Loading ${label}` : `${label} loaded`}
      </div>
      {loading ? skeleton : children}
    </div>
  );
}

export default SkeletonContainer;
